(function () {
  function getMarquee() {
    return document.querySelector('.section-header .ff-header-marquee[data-ff-header-marquee]');
  }

  function getHeaderSection() {
    return document.querySelector('.section-header');
  }

  function measureHeight(el) {
    if (!el) return 0;
    return Math.ceil(el.getBoundingClientRect().height);
  }

  function updateHeaderMetrics() {
    const marquee = getMarquee();
    const headerSection = getHeaderSection();
    const announcementHeight = measureHeight(marquee);
    const groupHeight = measureHeight(headerSection);

    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${groupHeight}px`);
    document.documentElement.style.setProperty('--ff-header-group-height', `${groupHeight}px`);
  }

  function scheduleUpdate() {
    updateHeaderMetrics();
    window.requestAnimationFrame(updateHeaderMetrics);
  }

  function init() {
    scheduleUpdate();
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('load', scheduleUpdate);

    const targets = [getMarquee(), getHeaderSection()].filter(Boolean);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(scheduleUpdate);
      targets.forEach((el) => observer.observe(el));
    }

    window.setTimeout(scheduleUpdate, 100);
    window.setTimeout(scheduleUpdate, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
